<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <h3 class="pageName">消息模板</h3>
      </div>
      <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="">
        <el-form-item label="" prop="userStatus">
          <el-select filterable v-model="queryParams.msgType" placeholder="消息类型" clearable @change="$forceUpdate()">
            <el-option v-for="(item, index) in messageTypeArr" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="pushThe">
          <el-select filterable v-model="queryParams.pushThe" placeholder="推送对象" clearable @change="$forceUpdate()">
            <el-option v-for="(item, index) in pushObjectArr" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="msgNode">
          <el-select filterable v-model="queryParams.msgNode" placeholder="触发节点" clearable @change="$forceUpdate()">
            <el-option v-for="(item, index) in nodeArr" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="time">
          <el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="添加开始时间"
            end-placeholder="添加结束时间" @change="$forceUpdate()"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
          <!-- <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新建模板</el-button> -->
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" element-loading-text="加载中" :data="list">
        <el-table-column label="序号" align="center" type="index" width="50" />
        <el-table-column label="模板名称" align="center" prop="msgName" />
        <el-table-column label="消息类型" align="center" >
          <template slot-scope="scope">
            {{ typeObj[scope.row.msgType] }}
          </template>
        </el-table-column>
        <el-table-column label="推送对象" align="center" prop="merchantName" >
          <template slot-scope="scope">
            {{ pushObj[scope.row.pushThe] }}
          </template>
        </el-table-column>
        <el-table-column label="触发节点" align="center" prop="msgNode" />
        <el-table-column label="消息模板" align="center" prop="msgTemplate" />
        <el-table-column label="启用/关闭" align="center" prop="isEnable" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isEnable" active-value="1" inactive-value="0" disabled
              @change="_switchConfig(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="添加人" align="center" prop="createBy" />
        <el-table-column label="添加时间" align="center" prop="createTime" />
        <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="250">
          <template slot-scope="scope">
            <el-button size="small" plain type="primary" @click="handleEdit(scope.row)" >编辑</el-button>
            <el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
        @pagination="_getList" />
    </el-card>

    <!-- 添加消息模板弹窗 -->
    <el-dialog :title="TmpMsgTitle" :visible.sync="dialogForm" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="125px">
        <el-form-item label="消息类型:" prop="msgType">
          <el-select v-model="form.msgType" placeholder="请选择消息类型" clearable filterable size="small" @change="msgTypeSelectBind">
            <el-option v-for="(item, index) in msgTypeSelect" :key="index" :label="item.name" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="触发节点:" prop="msgNode">
          <el-select v-model="form.msgNode" placeholder="请选择触发节点" clearable filterable size="small" @change="msgNodeBind">
            <el-option v-for="(item, index) in msgNodeSelect" :key="index" :label="item.shortDesc" :value="item.textValue"/>
          </el-select>
        </el-form-item>
        <el-form-item label="推送对象:" prop="pushThe">
          <el-input class="pushThe_input" type="text" size="small" v-model="pushTheVal" disabled />
        </el-form-item>
        <el-form-item label="消息参数:" prop="actId" style="display: flex;flex-wrap: wrap;">
          <ul class="msgUl">
            <li>地址：${actArea}</li>
						<li>活动名称：${actName}</li>
						<li>星闻标题：${headline}</li>
						<li>星闻审核原因：${refuseReason}</li>
						<li>开始时间：${actStartTime}</li>
						<li>星活审核原因：${handleDesc}</li>
          </ul>
          <p>提示：可复制参数放入到模板中</p>
        </el-form-item>

        <el-form-item label="推送账号:" prop="executorTheId" v-if="form.msgType == 4">
          <el-input :rows="4" type="textarea" placeholder="请输入推送账号，多个账号以英文分号;隔开"
                    v-model="form.executorTheId"></el-input>
        </el-form-item>
        
        <div v-if="form.msgType == 3">
          <el-form-item label="微信AppId:" prop="appId">
            <el-input clearable type="text" size="small" style="width: 340px" placeholder="请输入微信AppId"
                      v-model="form.appId"/>
          </el-form-item>
          <el-form-item label="微信AppSecret:" prop="appSecret">
            <el-input clearable type="text" size="small" style="width: 340px" placeholder="请输入微信AppId"
                      v-model="form.appSecret"/>
          </el-form-item>
          <el-form-item label="微信消息模板ID:" prop="templateId">
            <el-input clearable type="text" size="small" style="width: 340px" placeholder="请输入微信AppId"
                      v-model="form.templateId"/>
          </el-form-item>
        </div>
        <el-form-item label="消息模板:" prop="msgTemplate">
          <el-input :rows="4" type="textarea" placeholder="请输入消息模板"
                    v-model="form.msgTemplate"></el-input>
         <!-- <div class="viewBtn">
            <el-button type="primary">预览内容</el-button>
          </div>
          <el-input :rows="4" type="textarea" placeholder="请输入消息模板" v-model="contentView" disabled class="disabledCss"></el-input> -->
        </el-form-item>
        <el-form-item label="跳转链接:" prop="page">
          <el-input clearable type="text" size="small" style="width: 400px" placeholder="请输入跳转链接"
                    v-model="form.page"/>
        </el-form-item>
        <el-form-item label="启用/关闭:" prop="isEnable">
          <el-switch el-switch v-model="form.isEnable" active-value="1" inactive-value="0"></el-switch>
          <span class="note">*开启后消息即刻生效</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{ dialogBtnTxt }}</el-button>
        <el-button @click="dialogForm = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as API_Msg from "@/api/sportManage/msg";
export default {
  name: "msgList",
  data() {
    return {
      queryParams: {
        title: null,
        feedbackTatus: null,
        pageNum: 1,
        pageSize: 10,
        time: [],
      },
      loading: false,
      total: 0,
      list: [],
      nodeArr: [],
      messageTypeArr: [
        {
          name: '全部',
          value: null
        },
        {
          name: '小程序消息',
          value: 1
        },
        {
          name: '系统消息',
          value: 2
        },
        {
          name: 'H5消息',
          value: 3
        },
        {
          name: '公众号消息',
          value: 4
        },
      ],
      pushObjectArr: [
        {
          name: '全部',
          value: null
        },
        {
          name: '用户',
          value: 1
        },
        {
          name: '主理人',
          value: 2
        },
        {
          name: '商户',
          value: 3
        },
        {
          name: '系统管理员',
          value: 4
        }
      ],
      typeObj: {
        '1': '小程序消息',
        '2': '系统消息',
        '3': 'H5消息',
        '4': '公众号消息',
      },
      pushObj: {
        '1': '用户',
        '2': '主理人',
        '3': '商户',
        '4': '系统管理员',
      },
      msgTypeSelect: [
        { value: 1, name: '用户系统消息' },
        { value: 2, name: '短信消息' },
        { value: 3, name: '小程序消息' },
        { value: 4, name: '后台系统消息' }
      ],
      msgNodeSelect: [],
      form: {},
      rules: {
        msgType: [{ required: true, message: '请选择消息类型', trigger: 'blur' }],
        msgNode: [{ required: true, message: '请选择触发节点', trigger: 'change' }],
        appId: [{ required: true, message: '请输入微信AppId', trigger: 'change' }],
        appSecret: [{ required: true, message: '请输入微信AppSecret', trigger: 'blur' }],
        templateId: [{ required: true, message: '微信消息模板ID' }],
        msgTemplate: [{ required: true, message: '请输入消息模板' }],
        page: [{ required: true, message: '请选择广告图' }],
        executorTheId: [{ required: true, message: '请输入推送账号，多个账号以英文分号;隔开', trigger: 'blur' }],
        // pushThe:[{required: true,}]
      },
      dialogForm: false,
      dialogBtnTxt: '',
      TmpMsgTitle: '',
      pushTheVal:''
    };
  },
  created() {
    this._getList()
  },
  methods: {
    handleQuery() {
      this.queryParams.startTime = this.queryParams.time ? this.queryParams.time[0] : "";
      this.queryParams.endTime = this.queryParams.time ? this.queryParams.time[1] : "";
      this.queryParams.pageNum = 1;
      this._getList();
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
      this.queryParams.startTime = ''
      this.queryParams.endTime = ''
      this._getList();
    },
    _getList() {
      API_Msg.msgTemplateList(this.queryParams).then((res) => {
        console.log(res);
        this.total = res.data.total;
        this.list = res.data.list;
      })
    },
    
    // 新增模板
    handleAdd() {
      this._get_msg_node(3)
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.form = {
        isEnable:'1',
        msgType:3,
        msgNode:''
      }
      this.dialogBtnTxt = '确定'
      this.TmpMsgTitle = '添加消息模板'
      this.dialogForm = true
    },
    handleEdit(e) {
      console.log(e);
    },
    msgTypeSelectBind(e){
      this.form.msgNode = ''
      if(e == 1){
        this._get_msg_node(1)
      } else if(e == 3){
        this._get_msg_node(3)
      } else if(e == 4){
        this._get_msg_node(4)
      }
    },
    _get_msg_node(e){
      if(e == 4){
        this.nodeFunction('MSG_NODE_SYS')
      } else {
        this.nodeFunction('MSG_NODE')
      }
    },
    nodeFunction(e){
      let params = {}
      params.valueSetName = e
      // API_TmpMsg.MsgNode(params).then((res) => {
      //   this.msgNodeSelect = res.data  
      //   this.$forceUpdate()
      //   // setTimeout(() => {
      //   //   this.loading = false
      //   // }, 500)
      // })
    },
    // 变更触发节点
    msgNodeBind(e){
      this.pushTheVal = ''
      this.form.pushThe = ''
      if(e == 'N001' || e == 'N002' || e == 'N003' || e == 'N004' || e == 'N007' || e == 'N008'){
        this.form.pushThe = 1
        this.pushTheVal = '发布者'
      } else if(e == 'N005' || e == 'N006' || e == 'N009' || e == 'N010'){
        this.form.pushThe = 2
        this.pushTheVal = '参与者'
      } else if(e == 'N011' || e == 'N012'){
        this.form.pushThe = 3
        this.pushTheVal = '发布者、参与者'
      }
    },
    // 确定提交
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.msgId ? this._editAd() : this._addAd()
        } else {
          return false
        }
      })
    },
    _editAd() {

    },
    _addAd() {

    },
    _switchConfig(e) {
      // API_Base.switchConfig({ paramId: row.paramId, isEnable: row.isEnable, }).then((res) => {
      //   console.log(res);
      //   this.$message({
      //     message: "操作成功",
      //     type: "success",
      //   });
      // }).catch((err) => {
        
      // });
    }
  },
};
</script>

<style lang="scss">
.msgUl {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	li{
		width: 50%;
		text-align: left;
    list-style: none;
    margin: 0;
    padding: 0;
	}
}
</style>

